module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-23.865afa97.jpg";